export const useUtils = () => {
  const timeout = delay => new Promise(res => setTimeout(res, delay))

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  }

  return {
    timeout,
    validateEmail
  }
}